import _ from 'lodash'
import MetaMenu from '../../all/MetaMenu'
export default _.cloneDeep(MetaMenu).filter((item:any) => item.name !== 'Dades auxiliars')